// extracted by mini-css-extract-plugin
export default {"container":"aX-z","title":"bX-z","link":"cX-z"};